import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../../context/authContext";
import { COLOR, ChipsPendientes, Cabecera, Pagina } from "./reportesUi";

const OPCIONES = [
  { k: "diario", n: "1", emoji: "📋", titulo: "Reporte diario", sub: "Los pisos que te tocan hoy", ruta: "/supervisora/reportes/diario", color: COLOR.diario },
  { k: "residentes", n: "2", emoji: "🧑‍🎓", titulo: "Residentes", sub: "Un reporte por alumno, piso por piso", ruta: "/supervisora/reportes/residentes", color: COLOR.residentes },
  { k: "sustituciones", n: "3", emoji: "🔁", titulo: "Sustituciones", sub: "Cómo lo hacen las asistentas sustitutas", ruta: "/supervisora/reportes/sustituciones", color: COLOR.sustituciones },
];

const Reportes = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const usuario = user?.user || user || "";
  const [res, setRes] = useState(null);

  useEffect(() => {
    axios.get("/api/tareas/resumen").then((r) => setRes(r.data)).catch(() => setRes(null));
  }, []);

  return (
    <Pagina>
      <Cabecera titulo={`Reportes — ${usuario}`} emoji="📝" color="#1e3a5f" onVolver={() => navigate("/supervisora")}>
        {res && <ChipsPendientes hoy={res.total_hoy} retr={res.total_retrasados} grande />}
      </Cabecera>
      <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
        {OPCIONES.map((o) => (
          <button key={o.k} onClick={() => navigate(o.ruta)}
            style={{ border: `2px solid ${o.color}`, borderRadius: 20, background: "#fff", padding: "18px 16px", cursor: "pointer", fontFamily: "inherit", boxShadow: `0 4px 14px ${o.color}22`, display: "flex", flexDirection: "column", gap: 10, alignItems: "center" }}>
            <span style={{ display: "flex", alignItems: "center", gap: 14, width: "100%" }}>
              <span style={{ fontSize: 46, lineHeight: 1 }}>{o.emoji}</span>
              <span style={{ flex: 1, textAlign: "left" }}>
                <span style={{ display: "block", fontSize: 22, fontWeight: 900, color: o.color }}>{o.n}. {o.titulo}</span>
                <span style={{ display: "block", fontSize: 15, color: "#64748b", marginTop: 2 }}>{o.sub}</span>
              </span>
              <span style={{ fontSize: 34, color: o.color, fontWeight: 300 }}>›</span>
            </span>
            {res ? <ChipsPendientes hoy={res[o.k].hoy} retr={res[o.k].retrasados} /> : <span style={{ color: "#94a3b8", fontSize: 13 }}>Cargando…</span>}
          </button>
        ))}
      </div>
    </Pagina>
  );
};

export default Reportes;
